import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { PATH } from 'types/router';
import _ from 'lodash';
import playSprite from 'assets/icons/play.svg';

import { DtoOrTvodButtonsStyled } from './styles/DtoOrTvodButtonsStyled';

const DtoOrTvodButtons = ({
  isAvailable,
  hasTVOD,
  hasDTO,
  goTo,
  translate,
  minDTOPrice,
  minTVODPrice,
  buyingTariffs,
  isMobile,
}) => (
  <DtoOrTvodButtonsStyled>
    {isAvailable && (
      <Button
        buttonStyle="background"
        textSize="xs"
        size="l"
        align="center"
        textColor="white"
        onClick={() => goTo(PATH.PLAYER)}
        text={translate('watch')}
        icon={playSprite.id}
        iconSize={12}
        isMobile={isMobile}
      />
    )}
    {hasDTO &&
      !isAvailable && (
        <Button
          onClick={() => goTo(PATH.MOVIE_TARIFF_SELECT, { type: 'buy' })}
          text={translate('buy')}
          expandedTextPrice={
            _.get(buyingTariffs, 'dto', []).length > 1
              ? `${translate('from')} ${minDTOPrice}`
              : `${translate('for')} ${minDTOPrice}`
          }
          expandedTextQuality={
            _.get(buyingTariffs, 'dto', []).length > 1
              ? null
              : `${translate('in')} ${_.get(buyingTariffs, 'dto[0].qualityGroup', '')}`
          }
          buttonStyle="background"
          textSize="xs"
          size="s"
          align="center"
          textColor="white"
          isMobile={isMobile}
        />
      )}
    {hasTVOD &&
      !isAvailable && (
        <Button
          onClick={() => goTo(PATH.MOVIE_TARIFF_SELECT, { type: 'rent' })}
          text={translate('rent')}
          expandedTextPrice={
            _.get(buyingTariffs, 'tvod', []).length > 1
              ? `${translate('from')} ${minTVODPrice}`
              : `${translate('for')} ${minTVODPrice}`
          }
          expandedTextQuality={
            _.get(buyingTariffs, 'tvod', []).length > 1
              ? null
              : `${translate('in')} ${_.get(buyingTariffs, 'tvod[0].qualityGroup', '')}`
          }
          buttonStyle="background"
          textSize="xs"
          size="s"
          align="center"
          textColor="white"
          isMobile={isMobile}
        />
      )}
  </DtoOrTvodButtonsStyled>
);

DtoOrTvodButtons.propTypes = {
  hasTVOD: PropTypes.bool.isRequired,
  hasDTO: PropTypes.bool.isRequired,
  isAvailable: PropTypes.bool.isRequired,
  minTVODPrice: PropTypes.string.isRequired,
  minDTOPrice: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  buyingTariffs: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
};

DtoOrTvodButtons.defaultProps = {
  isMobile: false,
};

export default DtoOrTvodButtons;
